import { type ForwardedRef, type PropsWithChildren } from "react";

import clsx from "clsx";

import { useCSSVariable } from "@/utils/colorConverter";
import { type Table } from "@devexpress/dx-react-grid-bootstrap4";
import { useProductAnalyticsContext } from "@features/product-analytics/hooks";

import { NAME_COLUMN_ID, SELECTION_COLUMN_WIDTH } from "../constants";

interface Props extends PropsWithChildren<Table.DataCellProps> {
  forwardedRef?: ForwardedRef<HTMLTableCellElement>;
}

export const TableCell = ({
  column,
  value,
  children,
  row,
  forwardedRef,
  ...restProps
}: Props) => {
  const { hoveredDot } = useProductAnalyticsContext();
  let cellValue = children || value;
  if (
    cellValue === undefined ||
    cellValue === null ||
    Number.isNaN(cellValue)
  ) {
    cellValue = "";
  }

  const baseCell = useCSSVariable("--v2-bg-primary");
  const zebraCell = useCSSVariable("--v2-bg-secondary");
  const alternateCell = useCSSVariable("--v2-action-tertiary");
  const fontColor = useCSSVariable("--v2-text-primary");
  const borderColor = useCSSVariable("--v2-border-tertiary");

  const style = {
    ...(column.name === NAME_COLUMN_ID && {
      left: `${SELECTION_COLUMN_WIDTH}px`,
    }),
    ...(column.name === "proportional_spend" ||
    column.name === "proas" ||
    column.name === "pcac"
      ? {
          color: fontColor,
          borderColor: borderColor,
          backgroundColor:
            hoveredDot === row.id
              ? alternateCell
              : row.index % 2 === 0
              ? zebraCell
              : alternateCell,
        }
      : {
          color: fontColor,
          borderColor: borderColor,
          backgroundColor:
            row.index % 2 === 0
              ? hoveredDot === row.id
                ? alternateCell
                : baseCell
              : hoveredDot === row.id
              ? alternateCell
              : zebraCell,
        }),
  };

  return (
    <td
      ref={forwardedRef}
      className={clsx(
        "text-v2-primary text-right font-mono text-xs font-normal border-v2-tertiary",
        column.name !== "proas" &&
          column.name !== "pcac" &&
          column.name !== "proportional_spend" &&
          (row.index % 2 === 0 ? "even" : "odd"),
      )}
      {...restProps}
      style={style}
    >
      {cellValue}
    </td>
  );
};
